export enum ButtonStateEnum {
    Default = 'default',
    Hovered = 'hovered',
    Pressed = 'pressed',
    Disabled = 'disabled',
}
